import AbstractRequestTask from "../../AbstractRequestTask";
import Launcher from '../../../apa/Launcher';
import Utils from '../../../../utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../../RequestManagerConstants';

class CreateProfileTask extends AbstractRequestTask {

  constructor(params = {}, version = 'v1') {

    super();    

    this.firstname = params.firstname;
    this.user_image = params.user_image;
    this.version = version;
  }

  getMethod() {
    return "POST";
  }

  getHeaders() {
    return {
      'Content-Type': 'application/x-www-form-urlencoded'
    };
  }

  getParams() {
    const superParams = super.getParams();
    const params = {
      user_token: superParams.user_token,
      user_image: this.user_image
    };
    delete params.api_version;
    
    return Object.assign({}, params);
  }

  getQueryStringParams() {

    const superParams = super.getParams();
    const qsParams = Object.assign({}, superParams, { firstname: this.firstname});
    delete qsParams.HKS;
    delete qsParams.api_version;
    delete qsParams.user_token;
    return Utils.buildQueryParams(qsParams);

  }

  getUrl() {
    const protocol = 'http';
    const server = Launcher.get("akamai_mfwk");
    const endpoint = 'services/user';
    const version = this.version;
    const apiname = 'profile/create';
    return `${protocol}://${server}/${endpoint}/${version}/${apiname}?${this.getQueryStringParams()}`;
  }

  isValid(data){
    if (data.errors || data.status === 1 || data.response === 'error') {
      return false;
    }

    return true;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
    return ENABLE_MODAL_RETRIES;
  }
}

export default CreateProfileTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/profile/CreateProfileTask.js